import imgToSvg from './components/img-to-svg';
import lazyLoad from './components/lazy-load';

function initHiPriority() {
    imgToSvg.init();
	lazyLoad.init();
}

window.utils.lazyLoad = lazyLoad.init;
window.utils.imgToSvg = imgToSvg.init;

window.utils.domReady(function () {
	initHiPriority(); 
});